import { render, staticRenderFns } from "./BridalItemCard.vue?vue&type=template&id=55969cce"
import script from "./BridalItemCard.vue?vue&type=script&lang=js"
export * from "./BridalItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports